import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import './Services.css';

const Services = () => {
    const services = [
        {
            icon: 'fas fa-tooth',
            title: 'Soins Généraux',
            description: 'Consultations, détartrage, soins des caries, prévention et conseils personnalisés.',
            features: ['Consultation complète', 'Détartrage professionnel', 'Soins des caries', 'Prévention'],
            price: 'À partir de 50€',
            popular: false
        },
        {
            icon: 'fas fa-smile',
            title: 'Esthétique Dentaire',
            description: 'Blanchiment, facettes, restaurations esthétiques pour un sourire éclatant.',
            features: ['Blanchiment LED', 'Facettes céramique', 'Composite esthétique', 'Smile Design'],
            price: 'À partir de 200€',
            popular: true
        },
        {
            icon: 'fas fa-user-md',
            title: 'Chirurgie Dentaire',
            description: 'Extractions, implants, greffes osseuses avec techniques mini-invasives.',
            features: ['Implants dentaires', 'Extractions', 'Greffes osseuses', 'Chirurgie guidée'],
            price: 'À partir de 800€',
            popular: false
        },
        {
            icon: 'fas fa-child',
            title: 'Dentisterie Pédiatrique',
            description: 'Soins spécialisés pour enfants dans un environnement ludique et rassurant.',
            features: ['Première visite', 'Soins préventifs', 'Orthodontie précoce', 'Éducation'],
            price: 'À partir de 40€',
            popular: false
        },
        {
            icon: 'fas fa-procedures',
            title: 'Orthodontie',
            description: 'Alignement dentaire avec appareils classiques ou invisibles (Invisalign).',
            features: ['Bagues métalliques', 'Bagues céramique', 'Invisalign', 'Orthodontie linguale'],
            price: 'À partir de 3000€',
            popular: false
        },
        {
            icon: 'fas fa-brain',
            title: 'Parodontologie',
            description: 'Traitement des gencives et des maladies parodontales pour une bouche saine.',
            features: ['Détartrage profond', 'Surfaçage radiculaire', 'Greffe gingivale', 'Maintenance'],
            price: 'À partir de 150€',
            popular: false
        }
    ];

    return (
        <section id="services" className="services-section">
            <Container>
                <Row>
                    <Col lg={8} className="mx-auto text-center">
                        <div className="section-header">
                            <span className="section-badge">Nos Services</span>
                            <h2 className="section-title">
                                Une gamme complète de soins dentaires
                            </h2>
                            <p className="section-subtitle">
                                De la prévention aux traitements les plus avancés, notre équipe vous offre 
                                des soins de qualité avec les dernières technologies.
                            </p>
                        </div>
                    </Col>
                </Row>
                
                <Row className="g-4">
                    {services.map((service, index) => (
                        <Col lg={4} md={6} key={index}>
                            <Card className={`service-card h-100 w-100 ${service.popular ? 'popular-service' : ''}`}>
                                {service.popular && (
                                    <div className="popular-badge">
                                        <i className="fas fa-star me-1"></i>
                                        Plus Populaire
                                    </div>
                                )}
                                <Card.Body className="text-center">
                                    <div className="service-icon-wrapper">
                                        <i className={service.icon}></i>
                                    </div>
                                    <h4 className="service-title">{service.title}</h4>
                                    <p className="service-description">{service.description}</p>
                                    
                                    <ul className="service-features">
                                        {service.features.map((feature, idx) => (
                                            <li key={idx}>
                                                <i className="fas fa-check me-2"></i>
                                                {feature}
                                            </li>
                                        ))}
                                    </ul>
                                    
                                    <div className="service-price">{service.price}</div>
                                    
                                    <Button className="btn-service mt-3">
                                        En savoir plus
                                        <i className="fas fa-arrow-right ms-2"></i>
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default Services;